export default __webpack_public_path__ + "static/media/expert_profile_2.8acad060.jpg";